
import get from 'lodash-es/get'

export default function ({ app, req, $axios, redirect, store, route }) {
  $axios.onRequest(
    (config) => {
      config.url = config.url.replace(/^\/?api/g, '')
      app.$loaderShow()
      if (!config.url.startsWith('/public') && config.url.startsWith('/')) {
        // console.log("auth", app.$auth.token.get());
        // config.headers.common.Authorization = 'Bearer ' + app.$auth.token.get()
      }
    }
  )

  $axios.onResponse((response) => {
    app.$loaderHide()
    if (!store.getters['session/IGNORAR_QUANDO_NAO_LOGADO'].includes(route.name)) {
      const token = response.headers['x-app-token']
      if (token) {
        store.dispatch('session/setToken', token)
      }
    }
  })

  $axios.onResponseError(() => app.$loaderHide())

  $axios.onError((error) => {
    const status = get(error, 'response.status')

    if (!store.getters['session/IGNORAR_QUANDO_NAO_LOGADO'].includes(route.name)) {

      if (status === 401) {
        store.dispatch('session/logout')
        if (process.browser) {
          app.router.replace({name: 'login'})
        } else {
          redirect('/')
        }
      }
    }
    if (status === 412) {
      console.warn('🚨 HTTP 412 detectado - Sessão invalidada por novo login - Fazendo logout automático')
      console.log('Error details:', error.response)

      // Extrair mensagem se disponível
      const errorData = get(error, 'response.data', {})
      const mensagem = errorData.message || 'Sua sessão foi invalidada porque você fez login em outro dispositivo.'

      console.log('📩 Exibindo notificação:', mensagem)

      // Mostrar notificação
        if (process.browser && app.$notify) {
            app.$notify({
                message: mensagem,
                title: 'Sessão Invalidada',
                type: 'warn',
                timeout: 4000
            })
        } else {
            console.log('⚠️ Sistema de notificação não disponível')
        }

        // Fazer logout do sistema (igual ao método do default.vue)
        console.log('🚪 Executando logout...')
        try {
            // Usar o mesmo método de logout do layout default.vue
            app.$auth.logout().then(() => {
                console.log('✅ $auth.logout executado')
                const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin
                const domain = app.$auth.strategies.auth0.options.domain
                const returnUrl = `${baseUrl}/login`
                const logoutUrl = `https://${domain}/v2/logout?returnTo=${returnUrl}`

                console.log('🔄 Redirecionando para Auth0 logout:', logoutUrl)
                window.location.href = logoutUrl
            }).catch((err) => {
                console.error('❌ Erro no $auth.logout:', err)
                // Fallback para logout manual do store
                store.dispatch('session/logout')

                // Redirecionar mesmo com erro
                setTimeout(() => {
                    console.log('🔄 Fallback redirect para login...')
                    window.location.href = '/login?reason=sessao_invalidada'
                }, 1000)
            })
        } catch (err) {
            console.error('❌ Erro geral no logout:', err)
            // Fallback para logout manual do store
            store.dispatch('session/logout')

            // Redirecionar mesmo com erro
            setTimeout(() => {
                console.log('🔄 Fallback redirect para login...')
                window.location.href = '/login?reason=sessao_invalidada'
            }, 1000)
        }
    }

    if (status >= 500) {
      if (process.browser) {
        app.$notify({
          message: app.i18n.t(`erro.solicitacao`),
          title: app.i18n.t(`title.erro`),
          type: 'error'
        })
      } else {
        redirect('/erro')
      }
    }
  })
}
